import store from '@/state/store';
import { confirmByPhone } from '@/api/auth';
import registrationSlice from '@/state/registration.slice';
import authenticationSlice from '@/state/authentication.slice';
import { RegistrationStatus } from '@/contracts';
import { initSession } from '@/loaders/profile';
import { handleError } from '../common';

export default async (code: string) => {
  const state = store.getState();

  if (
    state.registration.status !== RegistrationStatus.CONFIRMATION ||
    !state.registration.claimId ||
    !state.registration.withPhone
  ) {
    throw new Error('Action cannot be performed.');
  }

  try {
    await confirmByPhone({
      claim: state.registration.claimId,
      code
    });

    store.dispatch(registrationSlice.actions.confirmed());
    store.dispatch(authenticationSlice.actions.finishLogin());
    await initSession();
  } catch (error) {
    store.dispatch(registrationSlice.actions.rejectRegistration());
    handleError(error);
  }
};
